<script setup lang="ts">
// Sierra's .note-var callout: a 3 px border in its tone and a 9 % tint of it. Text
// stays in the foreground colour. A crit banner is announced as an alert, the rest
// as a status.
import type { Tone } from '../types.ts';

withDefaults(defineProps<{ tone?: Tone }>(), { tone: 'info' });
</script>

<template>
  <div class="itc-banner" :class="`t-${tone}`" :role="tone === 'crit' ? 'alert' : 'status'">
    <slot />
  </div>
</template>
